import React, { useState, FormEvent, useEffect } from "react";
import { useParams } from "react-router-dom";
import WeCouldNotFindYou from "../WeCouldNotFindYou/WeCouldNotFindYouImpl";
import IsThisYou from "../IsThisYou/IsThisYouImpl";
import { useTraineeData } from "../../context/TraineeDataContext"; // Adjust the path as per your project structure
import { IWhoAreYou } from "./IWhoAreYou";

const WhoAreYou: React.FC<IWhoAreYou> = ({ httpService }) => {
	const [firstName, setFirstName] = useState<string>("");
	const [lastName, setLastName] = useState<string>("");
	const [phone, setPhone] = useState<string>("");
	const [isDataFetched, setIsDataFetched] = useState<boolean>(false);
	const { traineeData, setTraineeData } = useTraineeData();

	// this will run everytime the component is rendered
	useEffect(() => {
		/* local‑storage clean‑up + redirect */
		[
			`checkedIn-${locationIdParam}`,
			`locationId-${locationIdParam}`,
			`outOfDate-${locationIdParam}`,
			`traineeData-${locationIdParam}`,
			`companyData-${locationIdParam}`,
		].forEach((key) => localStorage.removeItem(key));
	}, []);

	const {
		// companyId: companyIdParam = '',
		// regionId: regionIdParam = '',
		locationId: locationIdParam = "",
	} = useParams<{ companyId: string; regionId: string; locationId: string }>();

	const handleSubmit = async (event: FormEvent) => {
		event.preventDefault();
		setIsDataFetched(false);

		let apiPath = "";
		let backupApiPath = "";

		if (phone) {
			// use the phone number to search for the trainee clean the phone number of everything but numbers and remove leading 1 if present
			const cleanPhoneNumber = phone.replace(/\D/g, "").replace(/^1/, "");
			apiPath = `trainee/phone/${cleanPhoneNumber}/${encodeURIComponent(
				locationIdParam,
			)}`;
			if (firstName && lastName) {
				backupApiPath = `trainee/name/${encodeURIComponent(
					firstName.toLowerCase().trim(),
				)}/${encodeURIComponent(
					lastName.toLowerCase().trim(),
				)}/${encodeURIComponent(locationIdParam)}`;
			}
		} else if (firstName && lastName) {
			apiPath = `trainee/name/${encodeURIComponent(
				firstName.toLowerCase().trim(),
			)}/${encodeURIComponent(
				lastName.toLowerCase().trim(),
			)}/${encodeURIComponent(locationIdParam)}`;
		} else {
			setIsDataFetched(true);
			setTraineeData(null);
			return;
		}

		try {
			let data = await httpService.getData(apiPath);
			if (!data && backupApiPath) {
				data = await httpService.getData(backupApiPath);
			}
			//check if data is an array then set the first element
			if (Array.isArray(data)) {
				setTraineeData(data[0]);
			} else if (data) {
				setTraineeData(data);
			} else {
				setTraineeData(null); // No valid data found
			}
		} catch (error) {
			console.error("Error during API request:", error);
			setTraineeData(null);
		} finally {
			setIsDataFetched(true);
		}
	};

	if (isDataFetched) {
		return traineeData ? (
			<IsThisYou data={traineeData} httpService={httpService} />
		) : (
			<WeCouldNotFindYou />
		);
	}

	return (
		<div className="tervuren-container__column-center bg-primary mh-100">
			<div className="tervuren-container__column-center-75">
				<h1 className="text-center mb-1 fw-500">
					Welcome! What's your phone number?
				</h1>
				<form
					onSubmit={handleSubmit}
					className="tervuren-container__column-center width-100 tervuren-container__column-center"
				>
					<label className="u-self-start" htmlFor="phone">
						Phone
					</label>
					<input
						type="text"
						id="phone"
						name="phone"
						autoComplete="tel"
						required={true}
						value={phone}
						onChange={(e) => setPhone(e.target.value.trim())}
					/>

					<button className="tervuren-button-primary mt-2" type="submit">
						Find Me
					</button>
				</form>
			</div>
		</div>
	);
};

export default WhoAreYou;
